import { AxiosInstance } from "axios";
import { Project, Lot, AOWithProjectDTO } from "../types/Project";

export const projectService = {
  getAllProjects: async (api: AxiosInstance): Promise<Project[]> => {
    try {
      const response = await api.get("/projects");
      return response.data as Project[];
    } catch (error: any) {
      console.error("Erreur lors de la récupération des projets :", error);
      throw error.response?.data || error;
    }
  },

  getProjectById: async (api: AxiosInstance, idProject: number): Promise<Project> => {
    try {
      const response = await api.get(`/projects/${idProject}`);
      return response.data as Project;
    } catch (error: any) {
      console.error(`Erreur lors de la récupération du projet ${idProject} :`, error);
      throw error.response?.data || error;
    }
  },

  createProject: async (api: AxiosInstance, project: Project): Promise<string> => {
    try {
      const response = await api.post("/projects", project);
      return response.data;
    } catch (error: any) {
      console.error("Erreur lors de la création du projet :", error);
      return error.response?.data || "Erreur lors de la création du projet";
    }
  },

  deleteProject: async (api: AxiosInstance, idProject: number): Promise<string> => {
    try {
      const response = await api.delete(`/projects/${idProject}`);
      return response.data;
    } catch (error: any) {
      console.error(`Erreur lors de la suppression du projet ${idProject} :`, error);
      return error.response?.data || "Erreur lors de la suppression du projet";
    }
  },

  createLot: async (api: AxiosInstance, idProject: number, lot: Lot): Promise<string> => {
    try {
      const response = await api.post(`/projects/${idProject}/lots`, lot);
      return response.data;
    } catch (error: any) {
      console.error(`Erreur lors de la création du lot pour le projet ${idProject} :`, error);
      return error.response?.data || "Erreur lors de la création du lot";
    }
  },

  updateLotPercentage: async (api: AxiosInstance, idLot: number, percentage: number): Promise<string> => {
    try {
      const response = await api.put(`/projects/lots/${idLot}/percentage?percentage=${percentage}`);
      return response.data;
    } catch (error: any) {
      console.error(`Erreur lors de la mise à jour du pourcentage du lot ${idLot} :`, error);
      return error.response?.data || "Erreur lors de la mise à jour du lot";
    }
  },

  isAlreadyAProject: async (api: AxiosInstance, project: Project): Promise<boolean> => {
    try {
      const response = await api.post("/projects/check-existence", project);
      return response.data as boolean;
    } catch (error: any) {
      console.error("Erreur lors de la vérification de l'existence du projet :", error);
      return false;
    }
  },

  getAOWithProjects: async (api: AxiosInstance): Promise<AOWithProjectDTO[]> => {
    try {
        const response = await api.get("/projects/ao-with-projects");
        return response.data as AOWithProjectDTO[];
    } catch (error: any) {
        console.error("Erreur lors de la récupération des AO avec projets :", error);
        throw error.response?.data || error;
    }
  }
};